/* The Tiny Toddlers redesign: product page behaviour (gallery, options, dispatch line, add to basket, stage strip,
   accordions, video, stage kit, related products). The header basket count and copy buttons live in ttt-home.js. */
(function () {
  var root = document.querySelector('[data-tp]');
  if (!root) return;
  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return [].slice.call((el || document).querySelectorAll(sel)); };
  var data = {};
  try { data = JSON.parse($('[data-tp-json]').textContent); } catch (e) {}
  var variants = data.variants || [];
  var form = document.getElementById('tp-form');
  var addBtn = $('[data-tp-add]');

  /* Money: the shop format, e.g. "£{{amount}}" */
  function money(cents) {
    var f = data.moneyFormat || '£{{amount}}';
    var n = (cents / 100).toFixed(2), parts = n.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]).replace(/\{\{\s*amount\s*\}\}/, withCommas).replace(/\{\{\s*[a-z_]+\s*\}\}/, withCommas);
  }

  /* Gallery */
  var slides = $$('.tp-slide', root);
  var at = Math.max(0, slides.findIndex(function (s) { return !s.hidden; }));
  function show(i) {
    if (!slides.length) return;
    at = (i + slides.length) % slides.length;
    slides.forEach(function (s, n) {
      s.hidden = n !== at;
      if (n === at) { var im = s.querySelector('img'); if (im) im.loading = 'eager'; }
    });
    $$('.tp-thumb, [data-tp-dots] button', root).forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.i === at)); });
    var c = $('[data-tp-counter]'); if (c) c.textContent = (at + 1) + ' / ' + slides.length;
  }
  function showMedia(id) {
    var n = slides.findIndex(function (s) { return s.dataset.media === String(id); });
    if (n > -1) show(n);
  }
  root.addEventListener('click', function (e) {
    var t = e.target.closest('.tp-thumb, [data-tp-dots] button');
    if (t) { show(+t.dataset.i); return; }
    if (e.target.closest('[data-tp-prev]')) { show(at - 1); return; }
    if (e.target.closest('[data-tp-next]')) { show(at + 1); return; }
  });
  /* Swipe on phones */
  var stage = $('[data-tp-stage]'), sx = null;
  if (stage) {
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 40) show(at + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  /* Dispatch line. In stock: countdown to 12:00 UK on working days. Otherwise the state from launch date / dispatch window. */
  var BANK = ['2026-12-25', '2026-12-28', '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-03', '2027-05-31', '2027-08-30', '2027-12-27', '2027-12-28'];
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function iso(d) { return d.toISOString().slice(0, 10); }
  function working(d) { var w = d.getUTCDay(); return w > 0 && w < 6 && BANK.indexOf(iso(d)) === -1; }
  function nextWorking(d) { var n = new Date(d); do { n.setUTCDate(n.getUTCDate() + 1); } while (!working(n)); return n; }
  function ukNow() {
    var p = {};
    try { new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; }); } catch (e) {}
    var d = p.year ? new Date(Date.UTC(+p.year, +p.month - 1, +p.day)) : new Date();
    return { date: d, mins: (parseInt(p.hour || '9', 10) % 24) * 60 + parseInt(p.minute || '0', 10) };
  }
  function fmt(d) { return DAYS[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()]; }
  var LONGM = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  /* "7–12 working days" -> arrival range: 7 and 12 working days from the next dispatch day, plus one day for delivery */
  /* delivery windows (custom.delivery_window) already include delivery: no extra day */
  var DELIV = data.windowKind === 'delivery';
  /* US, Nomad seats: approximate USD under the GBP price, added in the browser only; GBP stays the price in the HTML and structured data.
     Daily ECB rate via frankfurter.dev, cached 24 h; if unavailable the last rate is used for up to 7 days, then nothing is shown (31.10.2026) */
  if (data.fxUsd) {
    var fxApply = function (rate) {
      var old = 'approx. £52', neu = 'approx. £52 (about $' + Math.round(52 * rate) + ')';
      data.delLine = data.delLine.replace(old, neu);
      var fxSmall = $('[data-tp-dispatch-text] small');
      if (fxSmall && fxSmall.textContent.indexOf(neu) < 0) fxSmall.textContent = fxSmall.textContent.replace(old, neu);
      var fxNow = $('[data-tp-now]'); if (!fxNow) return;
      var fxLine = document.createElement('div'); fxLine.className = 'tp-approx';
      var fxSet = function () { var n = parseFloat(fxNow.textContent.replace(/[^0-9.]/g, '')); if (n) fxLine.textContent = 'approx. $' + Math.round(n * rate) + ', charged in GBP'; };
      fxSet(); fxNow.closest('.tp-price-row').after(fxLine);
      new MutationObserver(fxSet).observe(fxNow, { childList: true, characterData: true, subtree: true });
    };
    var fxSaved = null;
    try { fxSaved = JSON.parse(localStorage.getItem('ttt-fx-gbp-usd')); } catch (e) {}
    var fxAge = fxSaved && fxSaved.r ? Date.now() - fxSaved.t : Infinity;
    if (fxAge < 864e5) fxApply(fxSaved.r);
    else fetch('https://api.frankfurter.dev/v1/latest?base=GBP&symbols=USD').then(function (r) { return r.json(); }).then(function (d) {
      var rate = d && d.rates && d.rates.USD; if (!rate) throw new Error('no rate');
      try { localStorage.setItem('ttt-fx-gbp-usd', JSON.stringify({ r: rate, t: Date.now() })); } catch (e) {}
      fxApply(rate);
    }).catch(function () { if (fxAge < 6048e5) fxApply(fxSaved.r); });
  }
  function arriveOn(days) {
    var n = ukNow(), d = working(n.date) && n.mins < 12 * 60 ? n.date : nextWorking(n.date);
    for (var i = 0; i < days; i++) d = nextWorking(d);
    return DELIV ? d : nextWorking(d);
  }
  function verb(w) { return (DELIV ? 'Delivered in ' : 'Ships in ') + w; }
  function windowText(w) {
    if (!data.uk) return verb(w);
    var m = String(w || '').match(/(\d+)\s*[–-]\s*(\d+)/) || String(w || '').match(/(\d+)/);
    if (!m) return verb(w);
    var a = arriveOn(+m[1]), b = arriveOn(+(m[2] || m[1]));
    if (a.getUTCMonth() === b.getUTCMonth()) return 'Arrives ' + (a.getUTCDate() === b.getUTCDate() ? '' : a.getUTCDate() + '–') + b.getUTCDate() + ' ' + LONGM[b.getUTCMonth()];
    return 'Arrives ' + a.getUTCDate() + ' ' + LONGM[a.getUTCMonth()] + ' – ' + b.getUTCDate() + ' ' + LONGM[b.getUTCMonth()];
  }

  var current = variants.find(function (v) { return String(v.id) === String(($('[data-tp-id]') || {}).value); }) || variants[0];
  function stateOf(v) {
    if (!v || !v.available) return 'out';
    if (data.launch && data.launch > data.today) return 'launch';
    if (v.managed && v.qty <= 0) return data.window ? 'window' : 'order';
    return 'stock';
  }
  function tick() {
    if ($('[data-tp-region]')) return;  // UK-only product outside the UK: keep 'UK delivery only'
    var st = stateOf(current), box = $('[data-tp-dispatch]'), txt = $('[data-tp-dispatch-text]'), eta = $('[data-tp-eta]');
    if (!box) return;
    box.classList.toggle('tp-dispatch-pre', st !== 'stock');
    box.classList.toggle('tp-dispatch-out', st === 'out');
    box.classList.toggle('tp-dispatch-order', st === 'window');
    var dpp = $('[data-tp-dispatch-prop]'); if (dpp && st === 'window') { var wt = windowText(data.window), vb = verb(data.window); dpp.value = wt === vb ? vb : wt + ' (' + vb.toLowerCase() + ')'; dpp.disabled = false; /* outside the UK windowText() is the verb itself: don't repeat it */ }
    if (st === 'stock') {
      var n = ukNow(), left = 12 * 60 - n.mins, today = working(n.date) && left > 0;
      txt.innerHTML = today ? 'Order within <b>' + Math.floor(left / 60) + 'h ' + (left % 60) + 'm</b> for same-day dispatch' : 'Order now for dispatch the next working day';
      if (eta) {
        var disp = today ? n.date : nextWorking(n.date), arr = nextWorking(disp);
        eta.innerHTML = 'Order today, arriving <b>' + fmt(arr) + '</b> (mainland UK)';
        eta.hidden = false;
      }
    } else {
      txt.textContent = st === 'launch' ? 'Available to order · dispatched from ' + data.launchText
        : st === 'order' ? 'Available to order' : 'Currently out of stock';
      if (st === 'window') txt.innerHTML = (data.uk ? '<b>' + windowText(data.window) + '</b><small>' + verb(data.window) + ((current && current.price >= 3500) ? ' · free mainland UK delivery' : '') + '</small>' : '<b>' + verb(data.window) + '</b><small>' + (data.delLine || (DELIV ? 'UK delivery time' : 'Plus delivery time to your country')) + '</small>');
      if (eta) eta.hidden = true;
    }
  }

  /* Variant change */
  function setVariant(v, fromUser) {
    if (!v) return;
    current = v;
    var st = stateOf(v), sale = v.compare > v.price;
    var idInput = $('[data-tp-id]'); if (idInput) idInput.value = v.id;
    var now = $('[data-tp-now]'); if (now) { now.textContent = money(v.price); now.style.color = sale ? '' : 'var(--ink)'; }
    var was = $('[data-tp-was]'); if (was) { was.hidden = !sale; was.textContent = money(v.compare); }
    var save = $('[data-tp-save]'); if (save) { save.hidden = !sale; save.textContent = 'Save ' + money(v.compare - v.price); }
    var kb = $('[data-tp-klarna-btn]'); if (kb) kb.hidden = !(v.price >= 3000 && v.price <= 100000);
    var kl = $('[data-tp-klarna]'); if (kl) { kl.hidden = !(v.price >= 3000 && v.price <= 100000); var kt = $('[data-tp-kthird]'); if (kt) kt.textContent = money(Math.floor(v.price / 3)); }
    var p3 = $('[data-tp-payin3]'); if (p3) { p3.hidden = !(v.price >= 3000 && v.price <= 200000); var th = $('[data-tp-third]'); if (th) th.textContent = money(Math.floor(v.price / 3)); }
    var pp = document.getElementById('paypal-upstream-messaging-product'); if (pp) pp.setAttribute('data-pp-amount', (v.price / 100).toFixed(2));
    var sb = $('[data-tp-salebadge]'); if (sb) sb.hidden = !sale;
    var label = st === 'out' ? 'Out of stock' : 'Add to basket · ' + money(v.price);
    if (st === 'out') label = 'Out of stock';
    var al = $('[data-tp-add-label]'); if (al) al.textContent = label;
    if (addBtn && addBtn.dataset.tpGo) { delete addBtn.dataset.tpGo; addBtn.classList.remove('tp-go'); var sb = $('[data-tp-sticky-add]'); if (sb && sb.textContent === 'Go to basket') sb.textContent = 'Add to basket'; }
    if (addBtn) addBtn.disabled = st === 'out';
    var sa = $('[data-tp-sticky-add]'); if (sa) { sa.disabled = st === 'out'; sa.textContent = st === 'out' ? 'Out of stock' : 'Add to basket'; }
    var rb = $('[data-tp-region]'); if (rb) { if (al) al.textContent = rb.dataset.tpRegion; rb.disabled = true; if (sa) { sa.disabled = true; sa.textContent = 'UK delivery only'; } var xp = $('[data-tp-xpay]'); if (xp) xp.hidden = true; var dt = $('[data-tp-dispatch-text]'); if (dt) dt.textContent = 'UK delivery only'; var dpp2 = $('[data-tp-dispatch-prop]'); if (dpp2) dpp2.disabled = true; }  // UK-only product outside the UK
    var sn = $('[data-tp-sticky-now]'); if (sn) sn.textContent = money(v.price);
    var sw = $('[data-tp-sticky-was]'); if (sw) { sw.hidden = !sale; sw.textContent = money(v.compare); }
    var xp = $('[data-tp-xpay]'); if (xp) xp.hidden = st === 'out';
    var buy = $('[data-tp-buy]'); if (buy) buy.classList.toggle('tp-is-pre', st === 'launch' || st === 'window');
    var dp = $('[data-tp-dispatch-prop]');
    if (dp) {
      var txt = st === 'launch' ? 'Available to order · dispatched from ' + data.launchText : st === 'window' ? windowText(data.window) + ' (' + verb(data.window).toLowerCase() + ')' : '';
      dp.value = txt; dp.disabled = !txt;
    }
    if (v.media) showMedia(v.media);
    tick();
    if (fromUser && window.history && history.replaceState) {
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
    }
  }
  $$('[data-tp-option]', root).forEach(function (fs) {
    fs.addEventListener('click', function (e) {
      var b = e.target.closest('[data-value]'); if (!b) return;
      $$('[data-value]', fs).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      var nm = $('[data-tp-optname]', fs); if (nm) nm.textContent = b.dataset.value;
      var chosen = $$('[data-tp-option]', root).map(function (f) { var on = $('[aria-pressed="true"]', f); return on ? on.dataset.value : null; });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return chosen[i] === null || o === chosen[i]; }); });
      setVariant(v, true);
    });
  });

  /* Quantity */
  var qty = $('[data-tp-qty]');
  root.addEventListener('click', function (e) {
    if (!qty) return;
    if (e.target.closest('[data-tp-dec]')) qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
    else if (e.target.closest('[data-tp-inc]')) qty.value = Math.min(99, (parseInt(qty.value, 10) || 1) + 1);
  });

  /* Add to basket without leaving the page; afterwards the button reads "Go to basket" until the quantity or option changes */
  var cartUrl = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
  var stickyBtn = $('[data-tp-sticky-add]');
  var addLabelTxt = null, stickyTxt = stickyBtn ? stickyBtn.textContent : '';
  function setGo(on) {
    var al = $('[data-tp-add-label]');
    if (!addBtn || !al) return;
    if (on) { if (addLabelTxt === null || !addBtn.dataset.tpGo) addLabelTxt = al.textContent; addBtn.dataset.tpGo = '1'; addBtn.classList.add('tp-go'); al.textContent = '✓ Added · Go to basket'; if (stickyBtn) stickyBtn.textContent = 'Go to basket'; }
    else if (addBtn.dataset.tpGo) { delete addBtn.dataset.tpGo; addBtn.classList.remove('tp-go'); if (addLabelTxt !== null && al.textContent.indexOf('Go to basket') > -1) al.textContent = addLabelTxt; if (stickyBtn) stickyBtn.textContent = stickyTxt; }
  }
  if (form) {
    form.addEventListener('change', function () { setGo(false); });
    form.addEventListener('click', function (e) { if (e.target.closest('[data-tp-dec],[data-tp-inc]')) setGo(false); });
    form.addEventListener('submit', function (e) {
      if (addBtn && addBtn.dataset.tpGo) { e.preventDefault(); window.location.href = cartUrl; return; }
      if (!window.fetch) return;
      e.preventDefault();
      var err = $('[data-tp-error]'), added = $('[data-tp-added]');
      if (err) err.hidden = true;
      if (addBtn) addBtn.setAttribute('aria-busy', 'true');
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (res) {
        if (addBtn) addBtn.removeAttribute('aria-busy');
        if (!res.ok) { if (err) { err.textContent = res.j.description || res.j.message || 'Sorry, we could not add this to your basket.'; err.hidden = false; } return; }
        var q = parseInt((qty || {}).value || '1', 10) || 1;
        if (added) { $('[data-tp-added-msg]').textContent = q + ' × ' + (data.title || 'item') + ' added to your basket'; added.hidden = false; }
        setGo(true);
        document.dispatchEvent(new CustomEvent('t:added'));
      }).catch(function () { if (addBtn) addBtn.removeAttribute('aria-busy'); form.submit(); });
    });
  }

  /* Sticky bar on phones, once the main button has scrolled away */
  var sticky = $('[data-tp-sticky]');
  if (sticky && addBtn && 'IntersectionObserver' in window) {
    /* Phones: the bar is there from the first screen (owner 26.10.2026) and steps aside only while the main
       Add to basket button itself is on screen, so there is never a second copy right next to it. */
    sticky.classList.add('tp-show'); document.body.classList.add('tp-has-sticky');
    new IntersectionObserver(function (en) { var on = !en[0].isIntersecting; sticky.classList.toggle('tp-show', on); document.body.classList.toggle('tp-has-sticky', on); }).observe(addBtn);
    $('[data-tp-sticky-add]').addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click(); });
  }

  /* Stage strip: read the age and height range from the product's own text */
  (function fit() {
    var box = $('[data-tp-fit]'); if (!box) return;
    var t = ' ' + (data.fitText || '').replace(/\s+/g, ' ') + ' ';
    var low = t.toLowerCase().replace(/[–—]/g, '-');
    var fromBirth = /\b(from birth|birth to|birth-|newborn|0\+|0 months)/.test(low);
    var minM = fromBirth ? 0 : null, maxM = null;
    var m;
    // "15 months to 4 years", "6 months - 3 years"
    if ((m = low.match(/(\d{1,2})\s*(?:months?|m)\s*(?:to|-|up to)\s*(?:approx(?:imately)?\.?\s*|around\s*)?(\d{1,2})\s*(?:years?|yrs?|y)\b/))) { minM = +m[1]; maxM = +m[2] * 12; }
    // "birth to approximately 7 years", "4-12 years", "up to 4 years"
    else if ((m = low.match(/(?:birth|newborn)\s*(?:to|-|until|up to)\s*(?:approx(?:imately)?\.?\s*|around\s*|about\s*)?(\d{1,2})\s*(?:years?|yrs?|y)\b/))) { minM = 0; maxM = +m[1] * 12; }
    else if ((m = low.match(/\b(\d{1,2})\s*(?:-|to)\s*(\d{1,2})\s*(?:years?|yrs?)\b/))) { minM = +m[1] * 12; maxM = +m[2] * 12; }
    else if ((m = low.match(/up to (?:approx(?:imately)?\.?\s*|around\s*)?(\d{1,2})\s*(?:years?|yrs?)\b/))) { maxM = +m[1] * 12; if (minM === null) minM = 0; }
    else if ((m = low.match(/(?:birth|newborn)\s*(?:to|-|until|up to)\s*(\d{1,2})\s*months?/))) { minM = 0; maxM = +m[1]; }
    /* seats with several stages name the rear-facing age first ("birth to approx. 4 years ... approx. 12 years"): keep the highest age named */
    if (maxM !== null) {
      var ageRe = /(?:\b(?:to|until)\s+|-\s*)(?:approx(?:imately)?\.?\s*|around\s*|about\s*)?(\d{1,2})\s*(?:years?|yrs?)\b(?!\s*(?:warranty|guarantee))|approx(?:imately)?\.?\s*(\d{1,2})\s*(?:years?|yrs?)\b(?!\s*(?:warranty|guarantee))/g;
      while ((m = ageRe.exec(low))) { var yrs = +(m[1] || m[2]); if (yrs <= 12 && yrs * 12 > maxM) maxM = yrs * 12; }
    }
    if (minM === null || maxM === null || maxM <= minM) return;
    var cm = low.match(/\b(\d{2,3})\s*(?:cm)?\s*-\s*(\d{2,3})\s*cm\b/);
    var std = /i-size|r129/.test(low) ? 'i-Size R129' : (/r44/.test(low) ? 'R44/04' : '');
    // stops: 0 Expecting, 1 0–6 m, 2 6–12 m, 3 1–2 y, 4 2–4 y, 5 4+ y
    var bounds = [[-1, 0], [0, 6], [6, 12], [12, 24], [24, 48], [48, 999]];
    var on = [];
    bounds.forEach(function (b, i) { if (i > 0 && maxM > b[0] && minM < b[1]) on.push(i); });
    if (!on.length) return;
    $$('.tp-fstop', box).forEach(function (s) { s.classList.toggle('tp-on', on.indexOf(+s.dataset.stop) > -1); });
    var sp = $('[data-tp-fit-span]', box);
    if (sp) { sp.style.left = 'calc(100% / 12 * ' + (on[0] * 2 + 1) + ')'; sp.style.right = 'calc(100% / 12 * ' + ((5 - on[on.length - 1]) * 2 + 1) + ')'; }
    function age(mo) { return mo % 12 === 0 && mo >= 12 ? (mo / 12) + (mo === 12 ? ' year' : ' years') : mo + ' months'; }
    $('[data-tp-fit-title]', box).textContent = (minM === 0 ? 'From birth' : 'From ' + age(minM)) + ' to around ' + age(maxM);
    $('[data-tp-fit-sub]', box).textContent = [cm ? cm[1] + '–' + cm[2] + ' cm' : '', std].filter(Boolean).join(' · ');
    box.hidden = false;
  })();

  /* About this product: open side by side on desktop, accordions on phones (Description open) */
  var about = document.querySelector('[data-tp-about]');
  function aboutMode() {
    if (!about) return;
    var phone = window.innerWidth < 900;
    about.classList.toggle('tp-phone', phone);
    $$('.tp-acc', about).forEach(function (d) { d.open = !phone || d.classList.contains('tp-acc-desc'); });
  }
  if (about) {
    about.addEventListener('click', function (e) { if (e.target.closest('.tp-acc summary') && window.innerWidth >= 900) e.preventDefault(); });
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () { if ((lastW < 900) !== (window.innerWidth < 900)) aboutMode(); lastW = window.innerWidth; });
    aboutMode();
  }

  /* Video: the player is created only on click (gallery column on desktop, video section on phones) */
  $$('[data-tp-film]').forEach(function (film) {
    var vi = 0, player = film.querySelector('[data-tp-player]');
    var chapters = film.querySelector('[data-tp-chapters]');
    if (chapters) chapters.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      $$('button', chapters).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      vi = +b.dataset.i;
      var frame = player.querySelector('.tp-frame'); if (frame) frame.remove();
      var img = player.querySelector('.tp-poster-img'); if (img && b.dataset.poster) img.src = b.dataset.poster;
      player.querySelector('[data-tp-dur]').textContent = b.dataset.t;
      player.classList.remove('tp-playing');
    });
    player.addEventListener('click', function () {
      if (player.classList.contains('tp-playing')) return;
      var tpl = film.querySelector('[data-tp-video="' + vi + '"]'); if (!tpl) return;
      var wrap = document.createElement('div'); wrap.className = 'tp-frame';
      wrap.appendChild(tpl.content.cloneNode(true));
      player.appendChild(wrap); player.classList.add('tp-playing');
    });
  });

  /* Terms notice (no tick box on the product page): using an express button = agreeing to the terms shown next to it.
     Stamp the time into the hidden line item properties (PayPal Buy now) and, for Pay in 3 / Revolut, into the cart attributes. */
  function ukNowText(d) { try { return new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', dateStyle: 'medium', timeStyle: 'long' }).format(d); } catch (e) { return d.toString(); } }
  function stampTerms(via) {
    var now = new Date(), q = function (k) { return form && form.querySelector('[data-t-tn="' + k + '"]'); };
    if (q('utc')) q('utc').value = now.toISOString();
    if (q('uk')) q('uk').value = ukNowText(now);
    if (q('via')) q('via').value = 'Product page - ' + via;
    var ver = (document.querySelector('[data-t-terms-notice]') || {}).getAttribute ? document.querySelector('[data-t-terms-notice]').getAttribute('data-terms-version') : 'current';
    return { 'Terms accepted': 'Yes, by continuing to payment (terms notice shown on the product page)', 'Terms accepted at (UTC)': now.toISOString(),
             'Terms accepted at (UK)': ukNowText(now), 'Terms version': ver, 'Terms accepted on': location.host + location.pathname + ' - ' + via };
  }
  stampTerms('page viewed');

  /* Express buttons (PayPal via Shopify) are kept in a <template> and inserted when they come near the screen
     or on the first interaction, so their SDK and checkout scripts do not slow the first load. */
  (function deferWallets() {
    var w = document.querySelector('[data-tp-xp-defer]'), tpl = w && w.querySelector('template');
    if (!tpl) return;
    var done = false, io = null, evs = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
    function go() {
      if (done) return; done = true;
      w.appendChild(tpl.content.cloneNode(true)); tpl.remove(); w.removeAttribute('data-tp-xp-defer');
      if (io) io.disconnect();
      evs.forEach(function (ev) { window.removeEventListener(ev, go, true); });
    }
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) go(); }); }, { rootMargin: '300px 0px' });
      io.observe(w);
    } else go();
    evs.forEach(function (ev) { window.addEventListener(ev, go, { capture: true, passive: true }); });
  })();

  var ppWrap = document.querySelector('.tp-xp-paypal');
  if (ppWrap) {
    ['pointerdown', 'touchstart', 'focusin'].forEach(function (ev) { ppWrap.addEventListener(ev, function () { stampTerms('PayPal'); }, { passive: true }); });
    /* clicks inside PayPal's iframe do not reach the page: the window loses focus to the iframe instead */
    window.addEventListener('blur', function () { var a = document.activeElement; if (a && a.tagName === 'IFRAME' && ppWrap.contains(a)) stampTerms('PayPal'); });
  }

  /* Pay in 3 / Revolut Pay: add to basket, record the terms on the cart, then straight to checkout */
  $$('[data-tp-checkout]', root).forEach(function (b) {
    b.addEventListener('click', function () {
      if (!form) return;
      b.setAttribute('aria-busy', 'true');
      var termsAttrs = stampTerms(b.classList.contains('tp-xp-revolut') ? 'Revolut Pay' : b.classList.contains('tp-xp-klarna') ? 'Klarna Pay in 3' : 'PayPal Pay in 3');
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw r; return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: termsAttrs }) }); })
        .then(function () { location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'checkout'; })
        .catch(function () { b.removeAttribute('aria-busy'); var err = $('[data-tp-error]'); if (err) { err.textContent = 'Sorry, we could not add this to your basket.'; err.hidden = false; } });
    });
  });

  /* Stage kit ticks */
  var kit = document.querySelector('[data-tp-kit]');
  if (kit) kit.addEventListener('click', function (e) {
    var t = e.target.closest('.tp-tick'); if (!t) return;
    var on = t.getAttribute('aria-pressed') !== 'true';
    t.setAttribute('aria-pressed', String(on));
    t.closest('li').classList.toggle('tp-li-done', on);
    var total = +kit.dataset.total || 1, n = $$('.tp-tick[aria-pressed="true"]', kit).length;
    kit.querySelector('[data-tp-kit-progress]').textContent = n + ' of ' + total + ' sorted';
    var W = ['None', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten'], left = total - n;
    var kt = kit.querySelector('[data-tp-kit-title]');
    if (kt) kt.textContent = (n === 0 ? 'Nothing sorted yet. ' : (n === 1 && kit.querySelector('.tp-tick').getAttribute('aria-pressed') === 'true' ? kt.dataset.kind + ' sorted. ' : n + ' sorted. ')) + (left > 0 ? (W[left] || left) + ' to go.' : 'All set.');
    kit.querySelector('[data-tp-kit-bar]').style.width = (n / total * 100) + '%';
  });

  /* Related products (Shopify recommendations, rendered by the section) */
  var rel = document.querySelector('[data-tp-related]');
  if (rel && !rel.children.length && rel.dataset.url) {
    var ru = new URL(rel.dataset.url, location.href); ru = ru.pathname + ru.search;
    if (window.Shopify && Shopify.theme && Shopify.theme.role !== 'main') ru += '&preview_theme_id=' + Shopify.theme.id;
    fetch(ru).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var fresh = d.querySelector('[data-tp-related]');
      if (fresh && fresh.children.length) rel.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  }

  /* PayPal's own Pay in 3 message (PayPal Pay Later app) goes under the price and replaces our fallback line */
  (function paypalMessage() {
    var slot = $('[data-tp-ppmsg]'); if (!slot) return;
    var tries = 0;
    (function look() {
      var m = document.getElementById('paypal-upstream-messaging-product');
      if (m) {
        slot.appendChild(m);
        var own = $('[data-tp-payin3]'); if (own) { own.remove(); }
        return;
      }
      if (++tries < 20) setTimeout(look, 500);
    })();
  })();

  tick();
  setInterval(tick, 30000);
})();

/* Image zoom (owner 29.10.2026): magnifier on the main image; click/tap opens a full-screen viewer with arrows, swipe and Esc;
   click/tap inside the viewer zooms 2.5x and the image follows the pointer/finger. */
(function () {
  var stage = document.querySelector('[data-tp-stage]');
  if (!stage || !stage.querySelector('.tp-slide img')) return;
  var big = function (img) { var s = img.currentSrc || img.src; return s.replace(/([?&])width=\d+/, '$1width=2048'); };
  var imgs = function () { return Array.prototype.slice.call(stage.querySelectorAll('.tp-slide img')); };
  var current = function () { var s = stage.querySelector('.tp-slide:not([hidden]) img'); return Math.max(0, imgs().indexOf(s)); };

  var btn = document.createElement('button');
  btn.type = 'button'; btn.className = 'tp-zoom-btn'; btn.setAttribute('aria-label', 'Enlarge image');
  btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5M11 8v6M8 11h6"/></svg>';
  stage.appendChild(btn);

  var box = document.createElement('div');
  box.className = 'tp-lb'; box.hidden = true; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Product images');
  box.innerHTML = '<div class="tp-lb-pane"><img alt=""></div>' +
    '<button type="button" class="tp-lb-x" aria-label="Close">&times;</button>' +
    '<button type="button" class="tp-lb-nav tp-lb-prev" aria-label="Previous image"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M15 5l-7 7 7 7"/></svg></button>' +
    '<button type="button" class="tp-lb-nav tp-lb-next" aria-label="Next image"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M9 5l7 7-7 7"/></svg></button>' +
    '<span class="tp-lb-count"></span><span class="tp-lb-hint">Tap the image to zoom</span>';
  document.body.appendChild(box);
  var pane = box.querySelector('.tp-lb-pane'), view = pane.querySelector('img'), count = box.querySelector('.tp-lb-count');
  var at = 0, zoomed = false, lastFocus = null;

  function show(i) {
    var list = imgs(); if (!list.length) return;
    at = (i + list.length) % list.length;
    unzoom();
    view.src = big(list[at]); view.alt = list[at].alt || '';
    count.textContent = (at + 1) + ' / ' + list.length;
    box.querySelector('.tp-lb-prev').hidden = box.querySelector('.tp-lb-next').hidden = list.length < 2;
  }
  function open(i) { lastFocus = document.activeElement; show(i); box.hidden = false; document.documentElement.classList.add('tp-lb-on'); box.querySelector('.tp-lb-x').focus(); }
  function close() { box.hidden = true; unzoom(); document.documentElement.classList.remove('tp-lb-on'); if (lastFocus) lastFocus.focus(); }
  function unzoom() { zoomed = false; pane.classList.remove('tp-lb-zoomed'); view.style.transformOrigin = ''; }
  function pan(x, y) { var r = pane.getBoundingClientRect(); view.style.transformOrigin = ((x - r.left) / r.width * 100) + '% ' + ((y - r.top) / r.height * 100) + '%'; }

  /* open: magnifier, or a click/tap on the main image that was not a swipe */
  btn.addEventListener('click', function (e) { e.stopPropagation(); open(current()); });
  var down = null;
  stage.addEventListener('pointerdown', function (e) { down = [e.clientX, e.clientY]; });
  stage.addEventListener('click', function (e) {
    if (!e.target.closest('.tp-slide img') || e.target.closest('a,button')) return;
    if (down && Math.abs(e.clientX - down[0]) + Math.abs(e.clientY - down[1]) > 10) return;
    open(current());
  });

  box.querySelector('.tp-lb-x').addEventListener('click', close);
  box.querySelector('.tp-lb-prev').addEventListener('click', function () { show(at - 1); });
  box.querySelector('.tp-lb-next').addEventListener('click', function () { show(at + 1); });
  box.addEventListener('click', function (e) { if (e.target === box) close(); });
  pane.addEventListener('click', function (e) {
    if (e.target !== view) { if (!zoomed) close(); return; }
    zoomed = !zoomed; pane.classList.toggle('tp-lb-zoomed', zoomed); if (zoomed) pan(e.clientX, e.clientY);
  });
  pane.addEventListener('mousemove', function (e) { if (zoomed) pan(e.clientX, e.clientY); });
  var tx = null;
  pane.addEventListener('touchstart', function (e) { tx = [e.touches[0].clientX, e.touches[0].clientY]; }, { passive: true });
  pane.addEventListener('touchmove', function (e) { if (zoomed) pan(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
  pane.addEventListener('touchend', function (e) {
    if (tx === null || zoomed) { tx = null; return; }
    var dx = e.changedTouches[0].clientX - tx[0]; tx = null;
    if (Math.abs(dx) > 50) show(at + (dx < 0 ? 1 : -1));
  }, { passive: true });
  document.addEventListener('keydown', function (e) {
    if (box.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(at - 1);
    else if (e.key === 'ArrowRight') show(at + 1);
    else if (e.key === 'Tab') { var f = box.querySelectorAll('button:not([hidden])'); if (f.length) { var first = f[0], last = f[f.length - 1]; if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); } else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); } } }
  });
})();
